import { useTranslation } from 'react-i18next'

// Shown above the "Thử bot" panel on the FAQ page: what the preview does with
// the FAQ, so a manager does not conclude that customers already get these
// answers. Up to two lines; nothing when there is nothing to say.
export default function FaqSandboxNotice({ capabilities, status }) {
  const { t, i18n } = useTranslation()
  if (!capabilities?.sandbox) return null
  const lines = []
  if (capabilities.sandbox_uses_faq) {
    if (!capabilities.bot_uses_faq) lines.push(t('faq.sandbox.previewOnly'))
    // Entries on their way; a failed one is not "updating" and has its own chip.
    const unsynced = status ? status.pending + status.syncing : 0
    if (unsynced > 0) {
      lines.push(t('faq.sandbox.unsynced', { count: unsynced, formatted: Number(unsynced).toLocaleString(i18n.language) }))
    }
  } else if (capabilities.sandbox_faq_unavailable_reason === 'disabled') {
    lines.push(t('faq.sandbox.disabled'))
  } else if (capabilities.sandbox_faq_unavailable_reason) {
    lines.push(t('faq.sandbox.notReady')) // not_deployed, schema_missing
  }
  if (lines.length === 0) return null
  return (
    <div role="status" aria-live="polite" className="rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800">
      {lines.map((line) => <p key={line}>{line}</p>)}
    </div>
  )
}
